import type { ActionSchema } from 'app/developer-v3/types';

export function isExternalAction(action: ActionSchema) {
  return action?.key?.includes('external:');
}
